import React from "react";
import { useTranslation } from "react-i18next";

import img1 from "@/assets/explore-maatra/scattered-records-img1.png";
import img2 from "@/assets/explore-maatra/scattered-records-img2.png";
import img3 from "@/assets/explore-maatra/scattered-records-img3.png";
import { useS3VideoUrl } from "@/hooks/useS3VideoUrl";
import {
  VIDEO_DOCUMENTS_S3_FILE,
  VIDEO_SEARCH_S3_FILE,
  VIDEO_HEALTH_SUMMARY_S3_FILE,
} from "@/utils/constants";

import ExploreScreen, { ExploreCard } from "./ExploreScreen";

const BEIGE =
  "radial-gradient(ellipse at center, rgba(236,221,184,1) 0%, rgba(245,235,225,1) 100%)";
const PINK =
  "radial-gradient(ellipse at center, rgba(245,182,231,1) 0%, rgba(244,215,233,1) 100%)";
const PURPLE =
  "radial-gradient(ellipse at center, rgba(209,193,237,1) 0%, rgba(242,225,245,1) 100%)";

const ScatteredRecords: React.FC = () => {
  const { t } = useTranslation();

  const documentsVideoUrl = useS3VideoUrl(VIDEO_DOCUMENTS_S3_FILE);
  const searchVideoUrl = useS3VideoUrl(VIDEO_SEARCH_S3_FILE);
  const healthSummaryVideoUrl = useS3VideoUrl(VIDEO_HEALTH_SUMMARY_S3_FILE);

  const cards: [ExploreCard, ExploreCard, ExploreCard] = [
    {
      img: img1,
      title: t("auth.scatteredRecords.cards.c1"),
      thumbGradient: PINK,
      videoUrl: documentsVideoUrl,
      imgStyle: {
        width: "148.75%",
        height: "100%",
        left: "-0.75%",
        top: "0%",
      },
    },
    {
      img: img2,
      title: t("auth.scatteredRecords.cards.c2"),
      thumbGradient: PURPLE,
      videoUrl: searchVideoUrl,
      imgStyle: {
        width: "133.75%",
        height: "153.73%",
        left: "-1.25%",
        top: "-13.43%",
      },
    },
    {
      img: img3,
      title: t("auth.scatteredRecords.cards.c3"),
      thumbGradient: BEIGE,
      videoUrl: healthSummaryVideoUrl,
      imgStyle: {
        width: "110%",
        height: "113.43%",
        left: "-5%",
        top: "-5.97%",
      },
    },
  ];

  return (
    <ExploreScreen
      pill={t("auth.scatteredRecords.pill")}
      bodyText={t("auth.scatteredRecords.bodyText")}
      cards={cards}
    />
  );
};

export default ScatteredRecords;
